import * as React from "react";
function LgIcon() {
    return React.createElement("path", { d: "M7.05382 18.7077L6 17.6538L11.6538 12L17.3077 17.6538L16.2538 18.7077L11.6538 14.123L7.05382 18.7077ZM7.05382 12.7077L6 11.6538L11.6538 6L17.3077 11.6538L16.2538 12.7077L11.6538 8.12303L7.05382 12.7077Z", fill: "currentColor" });
}
export default LgIcon;
//# sourceMappingURL=Lg.js.map